import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Icon from '../../../ui/Icon'
import Logo from '../../../ui/logo/Logo'
import { ThemeToggle } from '../../../themeToggle/ThemeToggle'
import { LanguageToggle } from '../../../languageToggle/LanguageToggle'

import { SOCIAL_LINKS } from '../../../../constants/socialLinks'
import {
  FeatureFlags,
  isFeatureEnabled,
} from '../../../../constants/featureFlags'
import { getCurrentYear } from '../../../../utils/dateUtils'
import { useApp } from '../../../../contexts/AppContext'

const BOOKING_PHONE_HREF = 'tel:0774158714'
const DIRECTIONS_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
  'Strada Padurii 24, Zalau, Salaj'
)}`

export const Footer = () => {
  const { t } = useTranslation('footer')
  const { theme, setTheme, lang, setLang } = useApp()
  const appEnabled = isFeatureEnabled(FeatureFlags.FF_REGISTER)

  return (
    <footer className="footer">
      <div className="container-fluid footer-inner">
        <div className="row g-4 justify-content-xl-between footer-grid">
          <div className="d-none d-xl-flex col-xl-auto footer-brand">
            <Logo />
          </div>

          <nav
            className="col-12 col-sm-6 col-lg-4 col-xl-auto footer-column"
            aria-label={t('brand.label')}
          >
            <div className="footer-column-title">{t('brand.label')}</div>
            <Link to="/terms#c1">{t('links.about')}</Link>
            {SOCIAL_LINKS.map(social => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t(`social.${social.name}`)}
              </a>
            ))}
          </nav>

          <nav
            className="col-12 col-sm-6 col-lg-4 col-xl-auto footer-column"
            aria-label={t('play.label')}
          >
            <div className="footer-column-title">{t('play.label')}</div>
            {appEnabled && (
              <Link to="/guest-booking">{t('links.bookCourt')}</Link>
            )}
            <Link to="/terms#c8">{t('links.clubRules')}</Link>
          </nav>

          <nav
            className="col-12 col-sm-6 col-lg-4 col-xl-auto footer-column"
            aria-label={t('legal.label')}
          >
            <div className="footer-column-title">{t('legal.label')}</div>
            <Link to="/terms">{t('links.terms')}</Link>
            <Link to="/terms#c7">{t('links.cancellation')}</Link>
            <Link to="/terms#c10">{t('links.privacy')}</Link>
          </nav>

          <div className="col-12 col-sm-6 col-lg-4 col-xl-auto footer-column footer-contact">
            <div className="footer-column-title">{t('contact.label')}</div>
            <a href={BOOKING_PHONE_HREF} className="footer-info-row">
              <Icon name="phone" size={16} aria-hidden="true" />
              <span>{t('phone')}</span>
            </a>
            <a href={`mailto:${t('email')}`} className="footer-info-row">
              <Icon name="mail" size={16} aria-hidden="true" />
              <span>{t('email')}</span>
            </a>
            <a
              href={DIRECTIONS_URL}
              className="footer-info-row"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon name="pin" size={16} aria-hidden="true" />
              <span className="footer-info-secondary">{t('address')}</span>
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <span>
            {t('copyright', {
              year: getCurrentYear(),
            })}
          </span>
          <div className="footer-preferences">
            <div className="footer-preference">
              <ThemeToggle theme={theme} onThemeChange={setTheme} />
            </div>
            <div className="footer-preference">
              <LanguageToggle language={lang} onLanguageChange={setLang} />
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
